import {createAction} from 'redux-actions';
import * as ACTION from '../constants';

export const createWarehouseStaff = createAction(ACTION.CREATE_WAREHOUSE_STAFF.REQUEST, (params) => ({...params}));
export const clearState = createAction(ACTION.CLEAR_STATE);